module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-autocomplete', {
    attrs: {
      "suggestions": _vm.suggestions,
      "placeholder": "输入名称"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _c('br'), _vm._v("\n    禁用\n    "), _c('vbl-autocomplete', {
    attrs: {
      "suggestions": _vm.suggestions,
      "placeholder": "输入名称",
      "disabled": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bae6b46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblAutocomplete/example/vblAutocompleteExample.vue
// module id = 287
// module chunks = 0